<template>
  <div class="header">
    <div class="hea_box">
      <div class="logo">
        <img src="./image/logo3.png" alt="四川大学" />
      </div>
      <div class="Web_title">
        <span>教育培训</span>
      </div>
<!--      这一块暂时不要-->
      <div class="Web_search" v-show="false">
        <el-input
          placeholder=""
          v-model="keyWord"
          class="input-with-select"
        />
        <i class="el-icon-search" @click="goSearchList"></i>
      </div>

      <div class="Web_link">
        <a href="https://ccet.scu.edu.cn/" target="_blank">非学历培训云平台入口</a>
      </div>

      <div class="Web_contact">
        <div class="con_phone">业务联系电话:
          <img src="./image/1.png" alt="">
        </div>
        <div class="phone_num">
          028-85401299<br/>
          028-85408033<br/>
          <!-- 028-85501508 -->
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      keyWord:""
    };
  },
  methods:{
    goSearchList(){
      if(!this.keyWord){
        this.$message.error("请输入搜索关键字");
        return false;
      }
      this.$router.push({
        name:"searchList",
        path:'/searchList',
        params: {
          keyWord: this.keyWord
        }
      })
      // 判断当前页面路由是不是搜索结果页/searchList
      if(this.$route.path === '/searchList') {
        this.$parent.$children[2].getData(this.keyWord);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.header {
  width: 100%;
  height: 100px;
  background-color: #bb2a17;
  .hea_box {
    width: 1200px;
    height: 100px;
    margin: 0 auto;
    // background: url("./image/logoRight_02.jpg") no-repeat top right;
    & > div {
      float: left;
    }
    .logo {
      height: 86px;
      width: 370px;
      margin-top: 8px;
      img {
        width: 100%;
        height: 100%;
        // margin-top: 15px;
      }
    }
    .Web_title {
      height: 100px;
      width: 150px;
      text-align: right;
      line-height: 100px;
      color: #fff;
      font-size: 28px;
      font-weight: 600;
      span {
        margin-left: 20px;
      }
    }
    .Web_search {
      position: relative;
      height: 100px;
      width: 300px;
      margin-left: 100px;
      line-height: 100px;
      ::v-deep .el-input__inner {
        outline: none !important;
        border: 0;
        border-radius: 20px;
        padding-right: 50px;
      }
      ::v-deep .el-icon-search{
        position: absolute;
        top: 40px;
        right: 20px;
        font-size: 22px;
        color: #BA2A17;
        cursor: pointer;
      }
    }
    .Web_contact{
      height: 100px;
      width: 204px;
      margin-left: 50px;
      .con_phone{
        float: left;
        height: 56px;
        width: 90px;
        padding: 22px 0;
        font-size: 14px;
        text-align: center;
        color: #fff;
        img{
          width: 42px;
          padding-top: 6px;
        }
      }
      .phone_num{
        float: left;
        height: 56px;
        width: 114px;
        padding: 22px 0;
        font-size: 14px;
        text-align: center;
        color: #fff;
        line-height: 22px;
      }
    }
    .Web_link{
      font-size: 20px;
      height: 100%;
      display: flex;
      align-items: center;
      margin-left: 150px;
      a{
        // font-size: 16px;
        color: #fff;
        display: inline-block;
        padding: 10px;
        box-sizing: border-box;
        border: 2px solid #fff;
        border-radius: 20px;
      }
    }
  }
}
</style>
